<template>
  <div>
    <table class="link-list__table">
      <thead class="link-list__thead">
        <tr>
          <th class="link-list__cell-jacket">ジャケット</th>
          <th class="link-list__cell-genre">リリース種別</th>
          <th class="link-list__cell-artist u-text-align-left">アーティスト名</th>
          <th class="link-list__cell-title u-text-align-left">タイトル</th>
          <th class="link-list__cell-status">ステータス</th>
          <th class="link-list__cell-regist">レポート</th>
          <th class="link-list__cell-regist">Link設定</th>
          <th class="link-list__cell-link-show">Link画面</th>
        </tr>
      </thead>
      <tbody
        v-if="pagination.total > 0"
        class="link-list__tbody">
        <tr
          v-for="item in pagination.data"
          :key="item.id">
          <td>
            <div
              :class="[
                {'link-list__thumb--none':!item.coverart_filepath},
                'link-list__thumb']">
              <img
                v-if="item.coverart_filepath"
                :src="`/images/${item.coverart_filepath}`"
                alt="">
            </div>
          </td>
          <td>{{ item.type | toJapanese }}</td>
          <td class="u-text-align-left">{{ getMainArtists(item) }}</td>
          <!-- eslint-disable vue/no-v-html -->
          <td
            class="u-text-align-left"
            v-html="anyTitle(item)">
          </td>
          <!-- eslint-enable vue/no-v-html -->
          <td>{{ item.release_status_name }}</td>
          <td>
            <slot
              name="control1"
              :products="item" />
          </td>
          <td>
            <slot
              name="control2"
              :products="item" />
          </td>
          <td>
            <slot
              name="control3"
              :products="item" />
          </td>
        </tr>
      </tbody>
      <tbody
        v-else-if="!loading"
        class="link-list__tbody">
        <tr>
          <td
            class="empty-cell"
            :colspan="numberOfColumns">
            <slot name="empty" />
          </td>
        </tr>
      </tbody>
    </table>
    <pagination
      :pagination="pagination"
      @on-pagination-clicked="onPaginationClicked">
    </pagination>
  </div>
</template>

<script>

import Pagination from '../../../components/Pagination'
import {
  CMAP_RELEASE_STATUS_DSP_IN_REVIEW,
  CMAP_RELEASE_STATUS_PUBLISHED,
  CMAP_RELEASE_STATUS_EDITING,
  CMAP_RELEASE_STATUS_EDIT_UPLOADING,
  CMAP_RELEASE_STATUS_DSP_REJECTED,
  CMAP_RELEASE_STATUS_DSP_REAPPLY,
  CMAP_RELEASE_STATUS_APPEND_DSP,
  CMAP_RELEASE_STATUS_PREPARE_TAKE_DOWN,
} from '../../../consts/status'

export default {
  name: 'LinkAnalyticIndexTable',
  components: {
    Pagination,
  },
  filters: {
    toJapanese: (value) => (value === 'single' ? 'シングル' : 'アルバム'),
  },
  props: {
    keyword: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      pagination: {},
      timer: null,
      featuringPrefixes: {},
    }
  },
  computed: {
    numberOfColumns() {
      const totalColumns = 8
      return totalColumns
    },
  },
  watch: {
    keyword() {
      this.fetchItems(0)
    },
  },
  mounted() {
    this.fetchItems()
    this.fetchFeaturingPrefixes()
  },
  methods: {
    async fetchItems(page) {
      this.loading = true
      const { data } = await window.axios.get('/api/client/link-analytics', {
        params: {
          count: 20,
          release_status: [
            CMAP_RELEASE_STATUS_DSP_IN_REVIEW,
            CMAP_RELEASE_STATUS_PUBLISHED,
            CMAP_RELEASE_STATUS_EDITING,
            CMAP_RELEASE_STATUS_EDIT_UPLOADING,
            CMAP_RELEASE_STATUS_DSP_REJECTED,
            CMAP_RELEASE_STATUS_DSP_REAPPLY,
            CMAP_RELEASE_STATUS_APPEND_DSP,
            CMAP_RELEASE_STATUS_PREPARE_TAKE_DOWN,
          ],
          page,
          keyword: this.keyword,
        },
      })
      this.pagination = data
      this.loading = false
    },
    async fetchFeaturingPrefixes() {
      const { data } = await window.axios.get('/api/client/code/featuring-prefixes')
      this.featuringPrefixes = data
    },
    onPaginationClicked(page) {
      this.fetchItems(page)
      this.$emit('on-pagination-clicked', page)
    },
    anyTitle(item) {
      const title = item.title || (item.titles.length > 0 ? item.titles[0].title : '')
      let version = item.versions.length ? `${item.versions[0].version}` : ''
      let featuring = ''
      const firstTrack = item.tracks[0] ?? {}
      if (item.type === 'single'
        && Object.prototype.hasOwnProperty.call(firstTrack, 'meta_artists')) {
        const featuringArtists = []
        let prefix = ''
        firstTrack.meta_artists.featuring_artists.forEach((artist, index) => {
          featuringArtists.push(artist.name_ja)
          if (index === 0) prefix = this.featuringPrefixes[artist.prefix]
        })
        if (featuringArtists.length) featuring = `<br>${prefix} ${featuringArtists.join(',')}`
      }
      if (version.length) version = `(${version})`
      return `${title}${featuring}${version.length ? '<br>' : ''}${version}`
    },
    getMainArtists(item) {
      if (item.artists[0] && item.artists[0].type === 2) {
        // Various Artists
        return item.artists[0].name
      }
      if (item.type === 'single' && item.tracks.length > 0) {
        const artistNames = item.tracks[0].meta_artists.main_artists.map(a => {
          if (item.status === 0) {
            return a.name_ja
          }
          return a.pivot?.name ?? a.name_ja
        })
        return window._.uniq(artistNames).join(' / ')
      }
      // タイトルのフィーチャリングアーティストはメインアーティストとして表示しない
      const mainArtists = (item.artists || []).filter(a => a.pivot?.role !== 'featured artist')
      if (mainArtists.length === 0) {
        return item.artist_name
      }
      const artistNames = mainArtists.map(a => {
        if (item.status === 0) {
          return a.name_ja
        }
        return a.pivot?.name ?? a.name_ja
      })
      return window._.uniq(artistNames).join(' / ')
    },
  },
}
</script>

<style scoped>
.empty-cell {
  text-align: center;
  color: #505050;
  padding-top: 5vmin;
  padding-bottom: 5vmin;
}

</style>
